import { useEffect } from "react";
import { useState } from "react";
import * as APIModels from "../../../models";
import { Modal, Button } from "react-bootstrap";
import Select, { ActionMeta } from "react-select";
import { CoversheetService } from "../../../services/SubmissionService";
import { countSubscriptions } from "pubsub-js";

type MyCoversheetOptionType = {
    label: string;
    value: APIModels.CoversheetSave;
};

export type CoversheetModalProps = {
    show: boolean;
    coversheetSave: APIModels.CoversheetSave;
    coversheetOptions: MyCoversheetOptionType[];
    onCancel: () => void;
    onConfirm: () => void;
};

export default function CoversheetModal({
    show,
    coversheetSave,
    onCancel,
    onConfirm,
    coversheetOptions,
}: CoversheetModalProps) {
    const [newChecked, setNewChecked] = useState(false);
    const [existingChecked, setExistingChecked] = useState(false);
    const [existingSelected, setExistingSelected] = useState(false);
    const [options, setOptions] = useState([] as MyCoversheetOptionType[]);
    const [completedCoversheet, setCompletedCoversheet] = useState(
        new APIModels.CoversheetSave()
    );
    useEffect(() => {
        console.log("CoverSheetSave2 " + JSON.stringify(coversheetSave));
        const temp = [...coversheetOptions];
        temp.splice(0, 1);
        setOptions(temp);

        setCompletedCoversheet({
            ...coversheetSave,
            id: coversheetSave.id,
        });
        //setCompletedCoversheet(coversheetSave);
    }, [show]);

    const closeWindow = () => {
        onCancel();
    };

    const confirm = () => {
        if (
            (completedCoversheet.name == null ||
                completedCoversheet.name == undefined ||
                completedCoversheet.name == "") &&
            newChecked
        ) {
            alert("Enter a Name for Coversheet");
        } else if (!newChecked && !existingChecked) {
            alert("Please specify if this is a New or Existing Coversheet");
        } else if (existingChecked && !existingSelected) {
            alert("Please select the Existing Coversheet to be updated");
        } else {
            CoversheetService.add({
                body: completedCoversheet,
            }).then((resp) => {
                console.log("");
            });
            onConfirm();
        }
    };

    const onCoversheetChange = (
        value: MyCoversheetOptionType | null,
        actionMeta: ActionMeta<MyCoversheetOptionType>
    ) => {
        setExistingSelected(true);
        setCompletedCoversheet({
            ...completedCoversheet,
            name: value?.value.name,
            id: value?.value.id,
        });
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="child-modal-title-vcenter"
            centered
            style={{
                border: "2px solid #000",
            }}
        >
            <Modal.Header>
                <Modal.Title id="child-modal-title-vcenter">
                    Save Coversheet
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-16">
                        <div className="mt-2">
                            <h5 className="font-14 mb-3">Save As?</h5>
                            <div className="form-check">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="btnYesRelatedCases"
                                            name="relatedCases"
                                            checked={newChecked}
                                            onChange={(e) => {
                                                setNewChecked(true);
                                                setExistingChecked(false);
                                            }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="btnYesRelatedCases"
                                        >
                                            New Coversheet
                                        </label>
                                    </div>
                                    <div className="col-sm-6">
                                        {newChecked === true ? (
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtCaseTitle"
                                                aria-describedby="inputGroupPrepend"
                                                onChange={(event) => {
                                                    setCompletedCoversheet({
                                                        ...completedCoversheet,
                                                        name: event
                                                            .currentTarget
                                                            .value,
                                                    });
                                                }}
                                                placeholder="Name"
                                            />
                                        ) : (
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtCaseTitle"
                                                aria-describedby="inputGroupPrepend"
                                                disabled={true}
                                                placeholder="Name"
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    {" "}
                                    <div className="col-sm-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="btnNoRelatedCases"
                                            name="relatedCases"
                                            onChange={(e) => {
                                                setNewChecked(false),
                                                    setExistingChecked(true);
                                            }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="btnNoRelatedCases"
                                        >
                                            Existing Coversheet
                                        </label>
                                    </div>
                                    <div className="col-sm-6">
                                        {existingChecked === true ? (
                                            <Select
                                                id="selCaseType"
                                                name="selCaseType"
                                                value={options.filter(
                                                    (c) =>
                                                        c.label ===
                                                        completedCoversheet.name
                                                )}
                                                options={options}
                                                onChange={onCoversheetChange}
                                            />
                                        ) : (
                                            <Select
                                                id="selCaseType"
                                                name="selCaseType"
                                                isDisabled={true}
                                                value={null}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    type="button"
                    className="btn-danger"
                    onClick={closeWindow}
                >
                    Cancel
                </Button>
                <Button className="btn-primary " onClick={confirm}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
